module.exports = __webpack_public_path__ + "static/media/RobotoSlab-Regular.687919fb.ttf";